module.exports = __webpack_public_path__ + "static/media/meteringcase05.5b98adc2.png";